class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const button = event.target.closest('.cart-remove-button') || event.target;
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const matressProduct = button.getAttribute('data-matressproduct');
      const subProduct = button.getAttribute('data-subproduct');
      const variantId = button.getAttribute('data-variant-id');
      if((matressProduct != null && matressProduct != '') || (subProduct != null && subProduct != '')){
        const mainkey = button.getAttribute('data-main-key');
        const key = button.getAttribute('data-key');
        const quantity = button.getAttribute('data-qty');
        if(matressProduct != null){
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({'id': key,'properties': {'_additional_services': false },'quantity': quantity })
            });
          } finally {
            cartItems.updateQuantity(this.dataset.index, 0, '', variantId, mainkey);
          }
        } else {
          const formData = new FormData();
          if(mainkey) formData.append(`updates[${mainkey}]`, 0);
          if(key) formData.append(`updates[${key}]`, 0);
          try {
            const response = await fetch('/cart/update.js', {
              method: 'POST',
              body: formData
            });
            const data = await response.json();
            renderContentsUpdate(data);
          } finally {}
        }
      }else{
        cartItems.updateQuantity(this.dataset.index, 0, '', variantId);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.querySelector('#shopping-cart-line-item-status') || document.querySelector('#CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    this.getCartLeadTimeAndPromos()
  }

  cartUpdateUnsubscriber = undefined;

  async getCartLeadTimeAndPromos() {
    const data = await getCart();
    await getCartMaxQuantities();
    if (typeof syncCartQuantityStockLimits === 'function') {
      syncCartQuantityStockLimits();
    }
    updateCartLeadTime(data);
    deliveryPromos(data);
    setUpsell();
    const disposalPopup = getElements('.cart-item .js-Cart_mattressDisposalInfo');
    if (disposalPopup) {
      const disposalModal = document.body.querySelector('.js-Product_mattressDisposalModal');
      const disposalModalClose = document.body.querySelector('.js-Product_mattressDisposalModalClose');
      if (disposalModal && disposalModalClose) {
        disposalPopup.forEach(el => {
          el.addEventListener('click', () => disposalModal.setAttribute('aria-expanded', 'true'));
        });
        disposalModalClose.addEventListener('click', () => disposalModal.setAttribute('aria-expanded', 'false'));
      }
    }
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  async onChange(event) {
    const input = event.target;
    if (input.classList.contains('js-Cart_mattressDisposalCheckbox')) {
      // Extract values
      const currentParentNode = input.parentNode;
      const id = Number(currentParentNode.querySelector('input[name="disposalProductId"]').value);
      const subid = currentParentNode.querySelector('input[name="disposalProductId"]').value;
      const quantity = 1;
      const properties = Number(currentParentNode.querySelector('input[name="_matressProduct"]').value);
      const key = input.value;
      const productId = input.getAttribute('data-id');
      const mainQuantity = input.getAttribute('data-qty');
      const sectionId = input.getAttribute('data-sectionId');

      // Create FormData directly without a temporary form element
      const formData = new FormData();
      formData.append('form_type', 'product');
      formData.append('utf8', '✓');
      formData.append('id', id);
      formData.append('properties[_matressProduct]', properties);
      formData.append('product-id', productId);
      formData.append('section-id', sectionId);

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, properties: { '_additional_services': subid }, quantity: mainQuantity })
        });
        try {
          await addItemToCart(formData);
        } finally {
          if (input.classList.contains('cart-disposal')) window.location.reload(false);
        }
      } catch (error) {
        console.error('Error processing the request:', error);
      }
    } else {
      this.updateQuantity(
        input.dataset.index,
        input.value,
        document.activeElement.getAttribute('name'),
        input.dataset.quantityVariantId
      );
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      if (typeof this.prepareForSectionRender === 'function') {
        this.prepareForSectionRender();
      }
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then(async (responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          setUpsell();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.querySelector('#main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.querySelector('#main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, id) {
    let refreshPdpAfterUpdate = false;
    this.enableLoading(line);
    let body = '';
    if(id != '' && id != null){
      body = JSON.stringify({
        id,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
    }else{
      body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
    }

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const lineItemBefore =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        const resolvedVariantId =
          variantId ||
          lineItemBefore?.querySelector('quantity-input')?.getAttribute('data-id') ||
          lineItemBefore?.querySelector('[data-quantity-variant-id]')?.getAttribute('data-quantity-variant-id');
        const items = document.querySelectorAll('.cart-item');
        if (parsedState.errors) {
          if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        refreshPdpAfterUpdate = true;
        const isRemove = parseInt(quantity, 10) === 0;

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.querySelector('#main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartCountBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (cartCountBubble) cartCountBubble.innerHTML = parsedState.item_count;

        if (typeof this.prepareForSectionRender === 'function') {
          this.prepareForSectionRender();
        }

        try {
          this.getSectionsToRender().forEach((section) => {
            if (section.replaceWith) {
              const sectionHtml = parsedState.sections[section.section];
              if (!sectionHtml) return;

              const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const sourceElement = html.querySelector(section.selector);
              const targetElement = document.querySelector(section.selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
              return;
            }

            const sectionRoot = document.getElementById(section.id);
            if (!sectionRoot) return;

            const elementToReplace =
              sectionRoot.querySelector(section.selector) || sectionRoot;
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
        } catch (sectionError) {
          console.error(sectionError);
        }
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && quantityElement && updatedValue !== parseInt(quantityElement.value, 10)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        try {
          if (lineItem && quantityElement && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            const emptyInner = cartDrawerWrapper.querySelector('.drawer__inner-empty');
            const focusTarget =
              emptyInner?.querySelector('a') ||
              cartDrawerWrapper.querySelector('.drawer__close');
            if (emptyInner && focusTarget) trapFocus(emptyInner, focusTarget);
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }

          if (parsedState.item_count === 0 && typeof clearProductMaxQuantityCache === 'function') {
            clearProductMaxQuantityCache();
          } else if (isRemove && resolvedVariantId && typeof invalidateProductMaxQuantityCache === 'function') {
            invalidateProductMaxQuantityCache(resolvedVariantId);
          }

          if (isRemove && typeof releasePdpStockAfterCartRemove === 'function') {
            releasePdpStockAfterCartRemove(resolvedVariantId, parsedState);
          } else if (typeof syncPdpCartQuantityForVariant === 'function') {
            syncPdpCartQuantityForVariant(resolvedVariantId, parsedState);
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: parsedState,
            variantId: resolvedVariantId,
          });

          updateCartLeadTime(parsedState);
          setUpsell();
          if (parsedState.item_count === 0 && cartDrawerWrapper && typeof cartDrawerWrapper.closeUpsellPanel === 'function') {
            cartDrawerWrapper.closeUpsellPanel();
          }
          const disposalPopup = getElements('.cart-item__disposal .js-Cart_mattressDisposalInfo');
          if (disposalPopup) {
            const disposalModal = document.body.querySelector('.js-Product_mattressDisposalModal');
            const disposalModalClose = document.body.querySelector('.js-Product_mattressDisposalModalClose');
            if (disposalModal && disposalModalClose) {
              disposalPopup.forEach(el => {
                el.addEventListener('click', () => disposalModal.setAttribute('aria-expanded', 'true'));
              });
              disposalModalClose.addEventListener('click', () => disposalModal.setAttribute('aria-expanded', 'false'));
            }
          }
          window.loyaltylion && window.loyaltylion.ui.refresh();
        } catch (error) {
          console.error(error);
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.querySelector('#cart-errors') || document.querySelector('#CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(async () => {
        if (refreshPdpAfterUpdate && typeof refreshPdpQuantityStockLimits === 'function') {
          await refreshPdpQuantityStockLimits();
        }
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.querySelector('#cart-live-region-text') || document.querySelector('#CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (!html) return '';
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.querySelector('#main-cart-items') || document.querySelector('#CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = document.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    lineItem?.querySelector('quantity-input')?.setQuantityControlsDisabled(true);

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.querySelector('#main-cart-items') || document.querySelector('#CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = document.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));

    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    const quantityInput = lineItem?.querySelector('quantity-input');
    if (quantityInput?.refreshStockLimits) {
      quantityInput.refreshStockLimits();
    } else {
      quantityInput?.setQuantityControlsDisabled(false);
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

const renderContentsUpdate = async (data) => {
  const cart = getElement('cart-notification') || getElement('cart-drawer');
  const drawerInner = cart.querySelector('.drawer__inner');
  if (drawerInner?.classList.contains('is-empty')) drawerInner.classList.remove('is-empty');
  if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');

  const cartItems = cart?.querySelector('cart-drawer-items');
  if (typeof cartItems?.prepareForSectionRender === 'function') {
    cartItems.prepareForSectionRender();
  }

  try {
    const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const selectors = ['cart-drawer-items', '.drawer__footer'];
    selectors.forEach((selector) => {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    });
  } catch (e) {
    console.error("Error updating cart content:", e);
  }

  if (data?.item_count === 0 && typeof clearProductMaxQuantityCache === 'function') {
    clearProductMaxQuantityCache();
  }

  if (typeof releasePdpStockAfterCartRemove === 'function') {
    releasePdpStockAfterCartRemove(null, data);
  }

  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data });

  if (typeof refreshPdpQuantityStockLimits === 'function') {
    await refreshPdpQuantityStockLimits();
  }

  updateCartLeadTime(data);
  if (typeof syncCartQuantityStockLimits === 'function') syncCartQuantityStockLimits();
  deliveryPromos(data);
  setUpsell();
  const cartCountBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
  if (cartCountBubble && data?.item_count != null) cartCountBubble.innerHTML = data.item_count;
  window.loyaltylion && window.loyaltylion.ui.refresh();
};
